import * as React from "react";
import { forwardRef } from "react";
const SvgIconsNodearrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 7.797, height: 6.903, viewBox: "0 0 2.063 1.826", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M104.096 147.442c-.11 0-.188.134-.133.23l.881 1.525c.055.095.21.095.265 0l.881-1.526c.055-.095-.023-.229-.132-.229z", fill: "#c6c7fc", style: {
  strokeWidth: 0.264583
}, transform: "translate(-103.945 -147.442)" }));
const ForwardRef = forwardRef(SvgIconsNodearrow);
export default ForwardRef;
